import { Injectable, inject } from '@angular/core';

import { ThemesHelperService } from '../themes-helper/themes-helper.service';
import { FeatureCouponsService } from './coupons/feature-coupons.service';
import { FeatureCustomersService } from './customers/feature-customers.service';
import { FeatureObjectLockService } from './object-lock/feature-object-lock.service';

/**
 * FeatureService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/feature/feature.service.ts
 * (legacy AngularJS name 'FeatureService'). Aggregates the feature sub-services
 * (objectLock / customers / coupons) and resolves feature config flags through
 * ThemesHelperService.
 *
 * Sub-services and ThemesHelperService are all Angular 18 classes, so they are
 * injected directly (no ports). Registered back into AngularJS under
 * 'FeatureService' via downgradeInjectable in
 * app/upgrade/ng-downgraded-components.ts. Wave 3 item #26.
 */
@Injectable({ providedIn: 'root' })
export class FeatureService {
  objectLock = inject(FeatureObjectLockService);
  customers = inject(FeatureCustomersService);
  coupons = inject(FeatureCouponsService);
  private themesHelperService = inject(ThemesHelperService);

  constructor() {
    this.objectLock.init();
  }

  isEnabled(feature: { name: string; key?: string }) {
    if (feature.name && feature.key) {
      return this.themesHelperService.getFeaturesConfig(feature.name, feature.key);
    }

    return false;
  }
}
